if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form
                    .querySelector("[name=id]")
                    ?.removeAttribute?.("disabled");
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );

                // gift card product - recipient form
                this.recipientForm = this.querySelector("recipient-form");
            }

            getSubmitButton() {
                var formId = this.form.getAttribute("id");

                return (
                    this.querySelector('[type="submit"]') ||
                    document.querySelector('[form="' + formId + '"]')
                );
            }

            getMessageWrapper() {
                this.messageWrapper =
                    this.messageWrapper ||
                    this.querySelector(".message-wrapper");

                if (this.messageWrapper) {
                    return this.messageWrapper;
                }

                this.messageWrapper = createFromTemplate("message-wrapper");
                this.getSubmitButton()?.after(this.messageWrapper);

                return this.messageWrapper;
            }

            getCartJson() {
                return fetch(window.Shopify.routes.root + "cart.js", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }).then((response) => response.json());
            }

            async handleSubmitError(response) {
                // Show error message
                this.handleErrorMessage(response.description || 'Could not add to cart');
                
                // Show error toast
                const toast = document.createElement('div');
                toast.className = 'xt-toast xt-toast--error';
                toast.innerHTML = `
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:20px;height:20px;color:#ef4444;margin-right:8px;">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="15" y1="9" x2="9" y2="15"/>
                        <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                    ${response.description || 'Could not add to cart. Please try again.'}
                `;
                document.body.appendChild(toast);
                requestAnimationFrame(() => toast.classList.add('is-visible'));
                setTimeout(() => {
                    toast.classList.remove('is-visible');
                    setTimeout(() => toast.remove(), 300);
                }, 4000);
                
                // Only try to update cart sidebar if it exists
                const cart = document.querySelector("cart-sidebar");
                if (cart) {
                    const newCartJson = await this.getCartJson();
                    const itemCount = +cart?.querySelector?.(".cart-sidebar__total")?.dataset?.itemCount;
                    
                    if (itemCount !== newCartJson.item_count) {
                        await cart.reload();
                    }
                }
            }

            async onSubmitHandler(evt) {
                // Always prevent default - NEVER redirect to cart page
                evt.preventDefault();
                
                const cart = document.querySelector("cart-sidebar");
                const submitButton = this.getSubmitButton();
                if (submitButton.classList.contains("loading")) return;

                this.handleErrorMessage();

                if (!submitButton.querySelector(".loading-overlay"))
                    submitButton.prepend(
                        createFromTemplate("template-loading-overlay")
                    );

                submitButton.setAttribute("aria-disabled", true);
                submitButton.classList.add("loading");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                const formData = new FormData(this.form);
                
                // Only try to get sections if cart sidebar exists
                if (cart) {
                    cart.setActiveElement && cart.setActiveElement(document.activeElement);
                    formData.append(
                        "sections",
                        cart.getSectionsToRender().map((section) => section.id)
                    );
                }

                formData.append("sections_url", window.location.pathname);
                config.body = formData;

                try {
                    const response = await fetch(
                        `${routes.cart_add_url}`,
                        config
                    );
                    const jsonResponse = await response.json();

                    if (!response.ok || jsonResponse.status) {
                        this.handleSubmitError(jsonResponse);
                        return;
                    }

                    // Update cart contents silently (no auto-open)
                    if (cart && jsonResponse.sections) {
                        cart.renderContents(jsonResponse);
                    }
                    
                    // Always fetch fresh cart count to ensure accuracy
                    fetch('/cart.js')
                        .then(r => r.json())
                        .then(cartData => {
                            if (window.updateCartCount) {
                                window.updateCartCount(cartData.item_count);
                            } else {
                                // Fallback: update cart count elements directly
                                const cartCountEls = document.querySelectorAll('.cart-count, .xt-cart-count, [data-cart-count]');
                                cartCountEls.forEach(el => {
                                    el.textContent = cartData.item_count;
                                    el.classList.add('cart-count-bump');
                                    setTimeout(() => el.classList.remove('cart-count-bump'), 300);
                                });
                            }
                        });
                    
                    // Show success notification (stay on page - let customer continue shopping)
                    this.showAddedNotification(jsonResponse);

                    // cartSidebar && cartSidebar.triggerCartSidebarOnSubmit(response);
                    // hide gift card recipient form on submit
                    if (this.recipientForm)
                        this.hideRecipientForm(this.recipientForm);

                    // hide quickView popup on submit
                    document
                        .querySelector("#PopupModal-quickView")
                        ?.removeAttribute?.("open");
                } catch (error) {
                    console.error("Error submitting form:", error);
                } finally {
                    submitButton.classList.remove("loading");
                    submitButton.removeAttribute("aria-disabled");
                }
            }

            hideRecipientForm(recipientForm) {
                const input = recipientForm.querySelector("input");
                const fields = recipientForm.querySelector(".recipient-fields");

                if (input.checked) {
                    let animation = fields.animate(
                        { height: [fields.clientHeight + "px", "0"] },
                        { duration: 300, easing: "linear" }
                    );

                    input.checked = false;
                    animation.onfinish = () => {
                        fields.style.height = "0";
                    };
                }
            }

            showAddedNotification(response) {
                // Get product info
                const productTitle = response.product_title || response.title || 'Item';
                const productImage = response.image || response.featured_image?.url;
                const productPrice = response.final_price ? '$' + (response.final_price / 100).toFixed(2) : '';
                const productVariant = response.variant_title || '';
                
                // Remove existing notification
                const existing = document.querySelector('.xc-added-notification');
                if (existing) {
                    existing.style.transform = 'translateY(-120%)';
                    setTimeout(() => existing.remove(), 300);
                }
                
                // Inject styles if not already present
                if (!document.getElementById('xc-notification-styles')) {
                    const styleEl = document.createElement('style');
                    styleEl.id = 'xc-notification-styles';
                    styleEl.textContent = `
                        .xc-added-notification {
                            position: fixed;
                            top: 16px;
                            right: 16px;
                            z-index: 99999;
                            width: 360px;
                            max-width: calc(100vw - 32px);
                            background: #111113;
                            border: 1px solid rgba(255,255,255,0.08);
                            border-radius: 16px;
                            box-shadow: 
                                0 20px 60px rgba(0,0,0,0.5),
                                0 0 0 1px rgba(255,255,255,0.03) inset;
                            transform: translateY(-120%);
                            opacity: 0;
                            transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
                            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                            overflow: hidden;
                        }
                        .xc-added-notification.is-visible {
                            transform: translateY(0);
                            opacity: 1;
                        }
                        .xc-added-notification::before {
                            content: '';
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            height: 3px;
                            background: linear-gradient(90deg, #FB3A1B 0%, #ff6b4a 50%, #FB3A1B 100%);
                            background-size: 200% 100%;
                            animation: xc-progress 3.5s linear forwards;
                        }
                        @keyframes xc-progress {
                            from { background-position: 100% 0; }
                            to { background-position: 0% 0; }
                        }
                        .xc-notif-header {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            padding: 14px 16px 10px;
                            border-bottom: 1px solid rgba(255,255,255,0.06);
                        }
                        .xc-notif-check {
                            width: 22px;
                            height: 22px;
                            background: linear-gradient(135deg, #FB3A1B 0%, #ff6b4a 100%);
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-shrink: 0;
                        }
                        .xc-notif-check svg {
                            width: 12px;
                            height: 12px;
                            color: #fff;
                        }
                        .xc-notif-title {
                            flex: 1;
                            font-size: 13px;
                            font-weight: 600;
                            color: #fff;
                            letter-spacing: 0.01em;
                        }
                        .xc-notif-close {
                            width: 24px;
                            height: 24px;
                            background: transparent;
                            border: none;
                            border-radius: 6px;
                            color: rgba(255,255,255,0.4);
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            transition: all 0.15s ease;
                            padding: 0;
                        }
                        .xc-notif-close:hover {
                            background: rgba(255,255,255,0.08);
                            color: rgba(255,255,255,0.8);
                        }
                        .xc-notif-close svg {
                            width: 16px;
                            height: 16px;
                        }
                        .xc-notif-product {
                            display: flex;
                            gap: 14px;
                            padding: 14px 16px;
                        }
                        .xc-notif-image {
                            width: 64px;
                            height: 64px;
                            background: #1a1a1c;
                            border-radius: 10px;
                            overflow: hidden;
                            flex-shrink: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .xc-notif-image img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                            padding: 4px;
                        }
                        .xc-notif-details {
                            flex: 1;
                            min-width: 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            gap: 4px;
                        }
                        .xc-notif-name {
                            font-size: 14px;
                            font-weight: 600;
                            color: #fff;
                            line-height: 1.35;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }
                        .xc-notif-variant {
                            font-size: 12px;
                            color: rgba(255,255,255,0.45);
                        }
                        .xc-notif-price {
                            font-size: 15px;
                            font-weight: 700;
                            color: #FB3A1B;
                            margin-top: 2px;
                        }
                        .xc-notif-actions {
                            display: flex;
                            gap: 10px;
                            padding: 0 16px 16px;
                        }
                        .xc-notif-btn {
                            flex: 1;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            gap: 8px;
                            padding: 12px 16px;
                            font-size: 13px;
                            font-weight: 600;
                            text-decoration: none;
                            border-radius: 10px;
                            transition: all 0.2s ease;
                            cursor: pointer;
                            border: none;
                        }
                        .xc-notif-btn--secondary {
                            background: rgba(255,255,255,0.06);
                            color: #fff;
                            border: 1px solid rgba(255,255,255,0.1);
                        }
                        .xc-notif-btn--secondary:hover {
                            background: rgba(255,255,255,0.1);
                            border-color: rgba(255,255,255,0.15);
                        }
                        .xc-notif-btn--primary {
                            background: #FB3A1B;
                            color: #fff;
                        }
                        .xc-notif-btn--primary:hover {
                            background: #ff4d33;
                            transform: translateY(-1px);
                        }
                        .xc-notif-btn svg {
                            width: 16px;
                            height: 16px;
                        }
                        @media (max-width: 480px) {
                            .xc-added-notification {
                                top: auto;
                                bottom: 72px;
                                right: 12px;
                                left: 12px;
                                width: auto;
                                max-width: none;
                            }
                            .xc-notif-product {
                                padding: 12px 14px;
                            }
                            .xc-notif-image {
                                width: 56px;
                                height: 56px;
                            }
                            .xc-notif-actions {
                                padding: 0 14px 14px;
                                gap: 8px;
                            }
                            .xc-notif-btn {
                                padding: 11px 12px;
                                font-size: 12px;
                            }
                        }
                    `;
                    document.head.appendChild(styleEl);
                }
                
                // Create notification element
                const notification = document.createElement('div');
                notification.className = 'xc-added-notification';
                
                notification.innerHTML = `
                    <div class="xc-notif-header">
                        <div class="xc-notif-check">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M20 6L9 17l-5-5"/>
                            </svg>
                        </div>
                        <span class="xc-notif-title">Added to Cart</span>
                        <button class="xc-notif-close" aria-label="Close">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M18 6L6 18"/><path d="M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                    <div class="xc-notif-product">
                        <div class="xc-notif-image">
                            ${productImage 
                                ? `<img src="${productImage}" alt="${productTitle}" loading="eager">` 
                                : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:24px;height:24px;color:rgba(255,255,255,0.2);">
                                    <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
                                   </svg>`
                            }
                        </div>
                        <div class="xc-notif-details">
                            <div class="xc-notif-name">${productTitle}</div>
                            ${productVariant ? `<div class="xc-notif-variant">${productVariant}</div>` : ''}
                            ${productPrice ? `<div class="xc-notif-price">${productPrice}</div>` : ''}
                        </div>
                    </div>
                    <div class="xc-notif-actions">
                        <a href="/cart" class="xc-notif-btn xc-notif-btn--secondary">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                            </svg>
                            View Cart
                        </a>
                        <a href="/checkout" class="xc-notif-btn xc-notif-btn--primary">
                            Checkout
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
                            </svg>
                        </a>
                    </div>
                `;
                
                document.body.appendChild(notification);
                
                // Close button handler
                notification.querySelector('.xc-notif-close').addEventListener('click', () => {
                    notification.classList.remove('is-visible');
                    setTimeout(() => notification.remove(), 400);
                });
                
                // Animate in
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        notification.classList.add('is-visible');
                    });
                });
                
                // Auto close after 3.5 seconds (optimal UX based on research - Amazon/Apple use 3-4s)
                setTimeout(() => {
                    if (notification.parentNode) {
                        notification.classList.remove('is-visible');
                        setTimeout(() => notification.remove(), 400);
                    }
                }, 3500);
            }

            handleErrorMessage(errorMessage = false) {
                const messageWrapper = this.getMessageWrapper();

                // gift-card recipient form error messages
                if (
                    errorMessage.email ||
                    errorMessage.send_on ||
                    errorMessage.message
                )
                    errorMessage =
                        errorMessage.email ||
                        errorMessage.send_on ||
                        errorMessage.message;

                this.errorMessage =
                    this.errorMessage ||
                    messageWrapper.querySelector(".error-message");
                this.errorMessage.textContent = errorMessage || "";
                if (errorMessage) messageWrapper.removeAttribute("hidden");
                else messageWrapper.setAttribute("hidden", true);
            }
        }
    );
}
